import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import { AdalService } from "../shared/adal.service";
import { Observable } from "rxjs";

@Injectable()
export class AdalAccessGuard implements CanActivate {
    constructor(private adalService: AdalService) {}
    
  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.adalService.userInfo.profile;
  }
    public canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(childRoute, state);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/adal-access.guard.ts